var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filter-type"},[_c('p',[_vm._v(_vm._s(_vm.filter.name))]),_vm._v(" "),_c('div',{staticClass:"img",class:_vm.filter.name,style:({ backgroundImage: 'url(' + _vm.image + ')' }),on:{"click":_vm.selectFilter}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-179876b6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterType.vue
// module id = null
// module chunks = 